export const getStructureIds = (
	selectedNodes: number[] | undefined,
	nodeId: number | undefined,
) => {
	if (selectedNodes && selectedNodes.length > 0) {
		return selectedNodes
	}

	if (nodeId) {
		return [nodeId]
	}

	return []
}
